import React, { useEffect, useState } from "react";
import { Link, usePage } from "@inertiajs/react";
import ApiService from "@/Services/ApiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";

/**
 * Header unread badge for direct messaging. Hidden when the add-on is off.
 */
const MessagesNavLink = ({ compact = false }) => {
    const { props: pageProps, url } = usePage();
    const { globalSettings, auth } = pageProps;
    const enabled = Boolean(globalSettings?.direct_messaging_enabled);
    const canMessage = auth?.user?.can_message !== false;

    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!enabled || !auth?.user || !canMessage) {
            setUnreadCount(0);
            return undefined;
        }

        let cancelled = false;

        const fetchUnread = async () => {
            try {
                const response = await ApiService.get(
                    route("internal.conversations.unread-count"),
                );
                if (!cancelled) {
                    setUnreadCount(response.unread_count || 0);
                }
            } catch (e) {
                if (!cancelled) setUnreadCount(0);
            }
        };

        fetchUnread();
        const interval = setInterval(fetchUnread, 20000);

        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [enabled, auth?.user?.id, canMessage, url]);

    if (!enabled || !auth?.user) {
        return null;
    }

    const active = url?.startsWith("/messages");

    return (
        <Link
            href={route("messages.index")}
            className={`relative flex items-center gap-1.5 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base ${
                active ? "text-primary" : ""
            }`}
            aria-label="Messages"
        >
            <FontAwesomeIcon icon={faCommentDots} className="cursor-pointer" />
            {!compact && <span>Messages</span>}
            {unreadCount > 0 && (
                <span className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-meta-1 px-1 text-[10px] font-semibold text-white">
                    {unreadCount > 99 ? "99+" : unreadCount}
                </span>
            )}
        </Link>
    );
};

export default MessagesNavLink;
